import { useEffect, useState, FC } from "react";

//import { useDispatch } from 'react-redux';
import { registerLocale } from "react-datepicker";
import DatePicker from "react-datepicker";
import ru from "date-fns/locale/ru";
import { format } from 'date-fns';
import clsx from "clsx";

import Select from "../../custom/select/select";

import styles from "../headerBtn.module.scss";

interface IFiredEmployeesOptions {
  selectedEmployees?: {id: number}[];
};

const FiredAnEmployeeSection: FC<IFiredEmployeesOptions> = ({ selectedEmployees }) => {
  //const dispatch = useDispatch<AppDispatch>();
  console.log(selectedEmployees);
  const [error, setError] = useState<string | null>(null);
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);

  const today = new Date();

  useEffect(() => {
    registerLocale("ru", ru);
  }, []);

  const handleTextareaChange = (
    event: React.ChangeEvent<HTMLTextAreaElement>
  ) => {
    const { name, value } = event.target;
    console.log(name, value);
  };

  const selectChange = (event: { value: string | number, label: string }, name: string) => {
    console.log(event.value);
  };

  const handleDatePickerChange = (date: Date) => {
    if (date > new Date()) {
      setSelectedDate(date);
      setError(null);
    } else {
      setError('date');
    }
  };

  return (
    <div className={styles.block__info}>
      <div className={styles.check__list_block}>
        <div className={styles.limit__block}>
          <span>Причина увольнения:</span>
          <div className={styles.error__input_block}>
            <Select
              className={styles.filterSelect}
              value={{ value: '', label: 'По собственному желанию' }}
              isShowPlaceholder={true}
              propsChange={(event: { value: string, label: string }) =>
                selectChange(event, 'reasonFired')
              }
              options={[{ value: '', label: 'По собственному желанию' }]}
              placeholder={'Выбрать'}
              name='reasonFired'
              disabled={false}
              style={{width: '400px'}}
            />
          </div>
        </div>
        <div className={styles.limit__block}>
          <span>Комментарий к увольнению:</span>
          <div className={(styles.report__textarea_blockRight)}>
            <textarea
              onChange={handleTextareaChange}
              className={styles.textfield}
              name='commentFired'
              rows={10}
              placeholder=' '
            />
          </div>
        </div>
        <div className={styles.copy__block}>
          <span>Дата проведения увольнения:</span>
          <div className={clsx(styles.copy__data_picker, styles.copy__data_picker_small, error === 'date' && styles.error__reason_select)} >
            <DatePicker
              dateFormat="dd.MM.yyyy"
              placeholderText="Выберите дату"
              selected={selectedDate}
              value={format(today, 'dd.MM.yyyy')}
              locale={ru}
              name="dateFired"
              onChange={handleDatePickerChange}
            />
          </div>
        </div>
      </div>
    </div>
  )
};

export default FiredAnEmployeeSection;